import React from "react";
import ProyectoAPI from "../../api/proyectos-api";
import { Messages } from "../../helpers/message-helper";
import Fa from "../common/Fa";
import PlanoAPI from "../../api/plano-api";
import Table from "../common/Table";
import Loading from "../common/Loading";
import NoData from "../common/NoData";

/**
 *
 */
export default class PropietarioList extends React.Component {
  state = {
    loading: true
  };
  /**
   * Cuando el componente se monta se setea en el state el state del padre.
   */
  componentDidMount() {
    this.setState(this.props.data);
    this.props.onRef(this);
  }
  /**
   * Actualiza el state.
   * @param {*} data
   */
  setData(data) {
    this.setState(data);
  }
  /**
   * Se encarga de renderizar la grilla.
   */
  render() {
    if (this.state.loading) {
      return <Loading />;
    }
    const { propietarios } = this.state;
    return (
      <React.Fragment>
        <h3>Propietarios</h3>
        <hr />
        <table className="table is-fullwidth">
          <thead>
            <tr>
              <th>Nombres</th>
              <th>Tipo Documento</th>
              <th>Nro documento</th>
              <th>Dirección</th>
            </tr>
          </thead>
          <tbody>
            {!propietarios &&<tr><td colSpan="4"> <NoData /></td></tr>}
            {propietarios &&
              propietarios.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item.nombres}</td>
                    <td>{item.tipo_documento}</td>
                    <td>{item.nro_documento}</td>
                    <td>{item.direccion}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>

        <br />
      </React.Fragment>
    );
  }
}
